import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './ServiceTabs.css';
import marriageService from '../assets/Services/marriage.png';
import baptistService from '../assets/Services/baptism.png';
import morningPrayerService from '../assets/Services/prayer.png';
import funeralService from '../assets/Services/funeral.png';

const services = [
  {
    title: 'Marriage Service',
    image: marriageService,
    desc: 'Aliquam erat volutpat. Mauris ornare lorem eu finibus interdum.',
  },
  {
    title: 'Baptist Service',
    image: baptistService,
    desc: 'Aliquam erat volutpat. Mauris ornare lorem eu finibus interdum.',
  },
  {
    title: 'Morning Prayers',
    image: morningPrayerService,
    desc: 'Aliquam erat volutpat. Mauris ornare lorem eu finibus interdum.',
  },
  {
    title: 'Funerals Service',
    image: funeralService,
    desc: 'Aliquam erat volutpat. Mauris ornare lorem eu finibus interdum.',
  },
];

const ChurchServicesTabs = () => {
  const [activeTab, setActiveTab] = useState(services[0]);

  return (
    <section className=" is-fluid service-tabs" id="services">
         <section className="hero is-primary has-text-centered">
        <div className="hero-body">
          <p className="subtitle is-6 has-text-white has-text-weight-bold">Church Offers</p>
          <h1 className="title is-3 has-text-white">Our Services</h1>
        </div>
      </section>
      <div className="container has-text-centered">

        {/* Card Tabs */}
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1.2}
          navigation
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <div
                className={`card service-card ${activeTab.title === service.title ? 'is-active' : ''}`}
                onClick={() => setActiveTab(service)}
              >
                <div className="card-image">
                  <figure className="image is-4by3">
                    <img src={service.image} alt={service.title} />
                  </figure>
                </div>
                <div className="card-content">
                  <h3 className="title is-6 has-text-white">{service.title}</h3>
                  <p className="is-size-7 has-text-white">{service.desc}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Active Tab Content */}
        <div className="tab-detail box mt-5">
          <div className="columns is-vcentered is-variable is-5 is-multiline">
            <div className="column is-12-mobile is-6-desktop">
              <div className="content has-text-left p-5">
                <h3 className="title is-4 has-text-white">{activeTab.title}</h3>
                <p className='has-text-white'>{activeTab.desc}</p>
              </div>
            </div>
            <div className="column is-12-mobile is-6-desktop no-padding">
              <figure className="image tab-image">
                <img src={activeTab.image} alt={activeTab.title} />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChurchServicesTabs;
